module.exports = __webpack_public_path__ + "img/account.d486705d.svg";